import { render, staticRenderFns } from "./modalDirecciones.vue?vue&type=template&id=010734e6&scoped=true&"
import script from "./modalDirecciones.vue?vue&type=script&lang=js&"
export * from "./modalDirecciones.vue?vue&type=script&lang=js&"
import style0 from "./modalDirecciones.vue?vue&type=style&index=0&id=010734e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010734e6",
  null
  
)

export default component.exports